import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  PopoverController,
  ToastController,
} from '@ionic/angular';
import { UserService } from 'src/app/_services';
import { InvitationService } from '../invitation.service';
import { Invitation } from '../invitation.model';
import { TranslateService } from '@ngx-translate/core';
import { HeaderModel } from 'src/app/_component/header/header.model';
import { Guest } from '../guest/guest.model';
import { CompanyService } from 'src/app/app/company/company.service';
import { CompanyBasic } from 'src/app/app/company/company.model';
import { Location } from '@angular/common';
import { globalHelper } from 'src/app/_helpers/global';
import { BuildingService } from 'src/app/app/building/building.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { RowsLoaderService } from 'src/app/_services/rows-loader.service';
import { ModalInputComponent } from 'src/app/app/_component/modal-input/modal-input.component';
import {
  PopoverButton,
  PopoverEquipment,
} from '../../_component/popover/popover.model';
import { SpaceService } from 'src/app/_services/space.service';
import { SpaceModel } from 'src/app/_models/space.model';
import { ImagePreviewComponent } from '../../_component/image-preview/image-preview.component';
import { HeaderService } from 'src/app/_services/header.service';
import { BookingType } from 'src/app/_models/booking.model';
@Component({
  selector: 'app-edit-invitation',
  templateUrl: './edit-invitation.page.html',
  styleUrls: [
    './edit-invitation.page.scss',
    './../../../_styles/ion-grid-box.scss',
  ],
})
export class EditInvitationPage implements OnInit {
  constructor(
    public translateService: TranslateService,
    public invitationServ: InvitationService,
    public buildingServ: BuildingService,
    public modalController: ModalController,
    private loadingCtrl: LoadingController,
    private router: Router,
    private route: ActivatedRoute,
    private navCtrl: NavController,
    public p: ThisPlatform,
    public alertController: AlertController,
    public companyServ: CompanyService,
    private location: Location,
    public userServ: UserService,
    private toastCtrl: ToastController,
    private spaceService: SpaceService,
    private popoverController: PopoverController,
    private headerServ: HeaderService
  ) {}

  noGuest = false;
  invitationId: string;
  guestToPrint: any;
  headerInit: HeaderModel = {
    backDefaultHref: 'app/invitation',
    title: '',
    showRightButtonsOnlyOnMobile: true,
    rightButtons: [
      {
        iconName: 'trash',
        rolePermission: ['invitation.delete'],
        onClick: () => this.onDeleteInvitation(),
      },
    ],
  };

  buttonList: PopoverButton[] = [
    {
      name: 'ADD_INVITATION.PRINT_QR',
      icon: 'print-outline',
      eventType: 'printQr',
    },
    {
      name: 'ADD_INVITATION.ASSIGN_CARD',
      icon: 'card-outline',
      eventType: 'assignCard',
    },
  ];

  rowsLoader: RowsLoaderService;
  buildingSelected: any;
  loading = true;
  invitationSpaceLoading: boolean = false;
  currentLang = this.translateService.currentLang;
  userCompany: CompanyBasic = new CompanyBasic();
  invitationSpace: SpaceModel;

  errorStatusCode: number;
  isError = false;

  onGuestButtonClicked: boolean = false;
  refreshGuestCard: boolean = false;

  async ngOnInit() {
    this.invitationServ.invitation = new Invitation();

    this.route.paramMap.subscribe((paramMap) => {
      if (!paramMap.has('InvitationId')) {
        this.navCtrl.navigateBack('/app/invitation');
        return;
      }

      this.invitationId = paramMap.get('InvitationId');
      this.loading = true;
      this.refreshInvitation();
    });
  }

  async refreshInvitation() {
    const tempInvitations = await this.invitationServ
      .getInvitationSync(this.invitationId)
      .catch((err) => {
        this.errorStatusCode = err.error.statusCode;
      });

    if (!tempInvitations) {
      this.isError = true;
      this.loading = false;
      return;
    } else {
      this.invitationServ.invitation = tempInvitations;
    }
    if (this.invitationServ.invitation.idBuilding) {
      this.buildingSelected = await this.buildingServ
        .getBuildingSync(this.invitationServ.invitation.idBuilding)
        .catch((err) => {});
    }
    if (this.invitationServ.invitation.user.idCompany) {
      this.userCompany = await this.companyServ.getCompanySync(
        this.invitationServ.invitation.user.idCompany
      )
    }
    if (this.invitationServ.invitation.bookings?.length > 0) {
      this.invitationSpaceLoading = true;
      
      const space = this.invitationServ.invitation.bookings.filter( el => {
        return el.type == BookingType.Room
      })

      if(space?.length > 0) {
        const spaceId = space[0]?.bookingSpaces[0].idSpace;

        this.spaceService.getSpace(spaceId).subscribe((space: SpaceModel) => {
          this.invitationSpaceLoading = false;
          this.invitationSpace = space;
        });
      }
    }

    this.headerInit.title = this.invitationServ.invitation.title;
    this.loading = false;
    this.refreshGuestCard = false;
  }
  ionViewWillEnter() {
    this.headerServ.setHeaderInit(this.headerInit);
  }

  async save() {
    if (this.invitationServ.invitation.invitationGuests.length === 0) {
      this.noGuest = true;
      return;
    }
    this.loadingCtrl
      .create({
        keyboardClose: true,
        message: this.translateService.instant('SAVING'),
      })
      .then((loadingEl) => {
        loadingEl.present();
        this.invitationServ.createInvitation().subscribe(async (res) => {
          loadingEl.dismiss();
          this.router.navigateByUrl('/app/invitation');
        });
      });
  }

  onPrintQr(item: any) {
    this.guestToPrint = item;
    setTimeout(() => {
      window.print();
      this.guestToPrint = null;
    }, 10);
  }

  async onGuestEnterLeave(guest: Guest) {
    this.onGuestButtonClicked = true;
    this.refreshGuestCard = true;
    let entryLeave: boolean;
    let type = null;

    const dateStart = new Date(
      this.invitationServ.invitation.dateStart
    ).setHours(0, 0, 0, 0);
    const today = new Date().setHours(0, 0, 0, 0);

    if (dateStart === today) {
      entryLeave = true;
    } else {
      const confirm = await globalHelper.Alert(
        this.alertController,
        this.translateService,
        guest.entryDate
          ? 'ADD_INVITATION.GUEST_EXIT'
          : 'ADD_INVITATION.GUEST_ARRIVAL'
      );

      if (confirm) {
        entryLeave = true;
      } else {
        entryLeave = false;
      }
    }

    if (guest.entryDate && guest.leaveDate) {
      return;
    } else {
      if (!guest.entryDate && entryLeave) {
        type = 1;
      } else if (guest.entryDate && !guest.leaveDate && entryLeave) {
        type = 2;
      } else {
        return;
      }
    }

    this.invitationServ.invitationEntry(guest.id, type).subscribe(
      () => { this.refreshInvitation(); },
      () => {},
      () => {  this.onGuestButtonClicked = false; }
    );
  }

  async enterAssignCardNumberModal(guest: Guest) {
    let modal = await this.modalController.create({
      component: ModalInputComponent,
      componentProps: {
        modalTitle: this.translateService.instant(
          'ADD_INVITATION.ASSIGN_CARD_2'
        ),
        inputValue: guest.accessCard,
        inputType: 'text',
        saveTitle: this.translateService.instant('ADD_INVITATION.SAVE_BTN'),
      },
      animated: true,
      cssClass: 'add-edit-modal add-edit-modal--small',
    });

    modal.present();

    let detail = await modal.onDidDismiss();

    if (detail.data && detail.data.save && detail.data.inputValue) {
      this.invitationServ
        .invitationGuestAssingCard(guest.id.toString(), detail.data.inputValue)
        .subscribe(() => {
          this.refreshInvitation();
        });
    }
  }

  async onDeleteInvitation() {
    let confirm = await globalHelper.Alert(
      this.alertController,
      this.translateService
    );

    if (confirm) {
      this.invitationServ
        .deleteInvitation(parseInt(this.invitationId))
        .subscribe(() => {
          this.location.back();
        });
    }
  }

  async presentPopover(ev: any, guest) {
    let buttonList: PopoverButton[];
    let popoverEmptyInfo: string;

    if (
      guest.accessCard ||
      !this.userServ.checkRoles(['invitation.assign-card'])
    ) {
      buttonList = [this.buttonList[0]];

      if (this.p.renderMobile) {
        buttonList = [];
        popoverEmptyInfo = this.translateService.instant(
          'INVITATION.POPOVER_INFO'
        );
      }
    } else {
      
      if(!guest.leaveDate) {
        buttonList = this.buttonList;
      } else {
        buttonList = [this.buttonList[0]];
      }

      if (this.p.renderMobile) {
        if(!guest.leaveDate) {
          buttonList = [this.buttonList[1]];
        } else {
          buttonList = [];
          popoverEmptyInfo = this.translateService.instant(
            'INVITATION.POPOVER_INFO'
          );
        }
      }
    }

    if (buttonList.length > 0) {
      let popover = await globalHelper.Popover(
        this.popoverController,
        ev,
        buttonList,
        'user-assignment-view-share__popover'
      );
      if (popover) {
        if (popover.data === 'printQr') {
          this.onPrintQr(guest);
        } else if (popover.data === 'assignCard') {
          this.enterAssignCardNumberModal(guest);
        }
      }
    } else {
      let popover = await globalHelper.Popover(
        this.popoverController,
        ev,
        [],
        'user-assignment-view-share__popover',
        popoverEmptyInfo
      );
    }
  }

  async showEquipmentsList(event: any) {
    event.preventDefault();
    event.stopPropagation();
    let popover = await globalHelper.Popover(
      this.popoverController,
      event,
      null,
      'user-assignment-view-share__popover',
      'SPACE.ROOM.EQUIPMENT',
      null,
      this.invitationSpace.equipments as PopoverEquipment[]
    );
  }

  async onImagePreview($event, url) {
    $event.stopPropagation();
    $event.preventDefault();

    const modal = await this.modalController.create({
      component: ImagePreviewComponent,
      componentProps: { src: url },
      animated: true,
      cssClass: 'image-preview-present',
    });
    modal.present();
  }
}
